<template>
  <div class="app">
    <div style="padding-right:8px;display:flex;position: fixed;z-index: 99;background-color:white;flex-direction: column;"
      v-if="isMobile">
      <div style="display:flex;">
        <div style="display:flex;align-items: center;justify-content: center;">
          <img src="./img/zhanshi.png" alt="logo" class="logo" />
        </div>
        <Header :activeIndex="3" />
      </div>
      <div class="hengtiao">
        <div class="xiangji"><i class="el-icon-camera"></i></div>
        <div class="gerenxinxi">个人信息与能力测评报告</div>
      </div>
    </div>
    <div class="hengtiao1" v-if="!isMobile">
    </div>
    <div class="hengtiao" v-if="!isMobile">
      <div class="xiangji"><i class="el-icon-camera"></i></div>
      <div class="gerenxinxi">个人信息与能力测评报告</div>
    </div>
    <div style="display:flex;">
      <Header :activeIndex="3" style="position: fixed;margin-top:58px;" v-if="!isMobile" />
      <div class="personal-info-page">
        <div class="section">
          <h2>一、基本信息</h2>
          <div class="info-row">
            <label>姓名：</label>
            <span>{{ basicInfo.userName }}</span>
          </div>
          <div class="info-row">
            <label>性别：</label>
            <span>{{ basicInfo.gender }}</span>
          </div>
          <div class="info-row">
            <label>出生日期：</label>
            <span>{{ formatDate(basicInfo.birthday) }}</span>
          </div>
          <div class="info-row">
            <label>民族：</label>
            <span>{{ basicInfo.ethnicity }}</span>
          </div>
          <div class="info-row">
            <label>兴趣爱好：</label>
            <span v-if="basicInfo.hobbies">{{ basicInfo.hobbies }}</span>
            <span v-else>无</span>
          </div>
          <div class="info-row">
            <label>不良记录：</label>
            <span v-if="basicInfo.negativeRecord">{{ basicInfo.negativeRecord }}</span>
            <span v-else>无</span>
          </div>
          <div class="info-row">
            <label>联系电话：</label>
            <span>{{ basicInfo.phoneNumber }}</span>
          </div>
          <div class="info-row">
            <label>邮箱：</label>
            <span>{{ basicInfo.email }}</span>
          </div>
        </div>

        <div class="section">
          <h2>二、学习能力测评报告</h2>
          <div class="info-row">
            <label>入学年份：</label>
            <span>{{ formatDate(collegeReport.admissionDate) }}</span>
          </div>
          <div class="info-row">
            <label>毕业年份：</label>
            <span>{{ formatDate(collegeReport.graduationDate) }}</span>
          </div>
          <div class="info-row">
            <label>毕业院校：</label>
            <span>{{ collegeReport.almaMater }}</span>
          </div>
          <div class="info-row">
            <label>学历：</label>
            <span>{{ collegeReport.degree }}</span>
          </div>
          <div class="info-row">
            <label>专业：</label>
            <span>{{ collegeReport.major }}</span>
          </div>
          <div class="info-row">
            <label>学业成绩：</label>
            <span>{{ collegeReport.academic }}</span>
          </div>
          <div class="info-row">
            <label>学业成绩排名：</label>
            <span v-if="collegeReport.gradeRanking === '1'">10%以内</span>
            <span v-else-if="collegeReport.gradeRanking === '2'">30%以内</span>
            <span v-else-if="collegeReport.gradeRanking === '3'">50%以内</span>
            <span v-else-if="collegeReport.gradeRanking === '4'">50%以下</span>
          </div>
          <div class="info-row">
            <label>证书、职称与奖励：</label>
            <span>{{ collegeReport.certificate }}</span>
          </div>
          <div class="chart-container">
            <!-- 学习背景条（百分比） -->
            <div class="bar-container">
              <div class="bar-label">学习背景:</div>
              <div class="bar-background">
                <div class="bar-fill background-bar" :style="{ width: learningBackground + '%' }"></div>
              </div>
              <div class="bar-value">{{ learningBackground }}%</div>
            </div>

            <!-- 学习能力条（小数） -->
            <div class="bar-container">
              <div class="bar-label">学习能力:</div>
              <div class="bar-background">
                <div class="bar-fill ability-bar" :style="{ width: learningAbility + '%' }"></div>
              </div>
              <div class="bar-value">{{ learningAbility }}%</div>
            </div>
          </div>
        </div>

        <div class="section">
          <h2>三、工作及实习经历</h2>
          <div class="info-row">
            <label>实习经历：</label>
            <span>{{ workExperience.internship }}</span>
          </div>
          <div class="info-row">
            <label>期待工作地点：</label>
            <span>{{ workExperience.preferredLocation }}</span>
          </div>
          <div class="info-row">
            <label>霍兰德测试结果：</label>
            <span>{{ jieguo }}</span>
          </div>
          <div class="holland-chart-container">
            <div v-for="(item) in scaledScores" :key="item.type" class="single-chart">
              <div class="chart-header">
                <span class="type-label" v-if="item.type === 'A'">创造能力、审美能力</span>
                <span class="type-label" v-else-if="item.type === 'C'">执行能力、细致能力</span>
                <span class="type-label" v-else-if="item.type === 'E'">领导能力、说服能力</span>
                <span class="type-label" v-else-if="item.type === 'I'">分析能力、探索能力</span>
                <span class="type-label" v-else-if="item.type === 'R'">动手能力、问题解决能力</span>
                <span class="type-label" v-else-if="item.type === 'S'">沟通能力、共情能力</span>
                <span class="score-label">得分: {{ (item.scaledScore / 10 * 100).toFixed(0) }}%</span>
              </div>
              <div class="chart-bar-container">
                <div class="chart-bar-bg"></div>
                <div class="chart-bar-progress" :style="{
                  width: `${item.scaledScore * 10}%`,
                  backgroundColor: getColor(item.type),
                }"></div>
                <div class="chart-ticks">
                  <span v-for="i in 11" :key="i" class="tick" :style="{ left: `${(i - 1) * 10}%` }">
                    {{ i - 1 }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="section">
          <h2>四、未来职业发展路径及所需要的能力</h2>
          <div v-for="job in jobsfazhan" :key="job.jobName" style="text-align: left;">
            <div class="info-row" style="margin-top:10px;">
              <label>岗位名称：</label>
              <span>{{ job.jobName }}</span>
            </div>
            <div class="info-row">
              <label>所需技能：</label>
              <span>
                <li v-for="(skill, index) in job.majorSkills" :key="index">
                  {{ skill }}
                </li>
              </span>
            </div>
            <div class="info-row">
              <label>发展路径：</label>
              <span>{{ job.careerPath }}</span>
            </div>
          </div>
          <div v-if="showMoreButton" style="margin-top: 20px; text-align: center;">
            <button @click="handleViewMore" class="view-more-btn">
              查看更多
            </button>
          </div>
        </div>

        <div class="section">
          <h2>五、个人特点|建议|提升空间</h2>
          <div class="info-row" style="margin-top: 10px;">
            <label>个人特点：</label>
            <div style="text-align: left;">
              <span v-for="(item, index) in academic.feature" :key="index">
                {{ item }}<br />
              </span>
            </div>
          </div>
          <div class="info-row" style="margin-top: 10px;">
            <label>建议：</label>
            <div style="text-align: left;">
              <span v-for="(item, index) in academic.improvement" :key="index">
                {{ item }}<br />
              </span>
            </div>
          </div>
          <div class="info-row" style="margin-top: 10px;">
            <label>提升空间：</label>
            <div style="text-align: left;">
              <span v-for="(item, index) in academic.suggestion" :key="index">
                {{ item }}<br />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from './Header.vue';
import Footer from './Footer.vue'
export default {
  name: 'usereport',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      userId: sessionStorage.getItem("userId"),
      basicInfo: {
        userName: '',
        gender: '',
        birthday: '',
        ethnicity: '',
        phoneNumber: '',
        email: '',
        hobbies: '',
        negativeRecord: ''
      },
      // 学习能力测评报告
      collegeReport: {
        admissionDate: '',
        graduationDate: '',
        almaMater: '',
        degree: '',
        major: '',
        academic: '',
        gradeRanking: '',
        certificate: ''
      },
      // 工作及实习经历
      workExperience: {
        internship: '',
        preferredLocation: '',
        typeScore: '',
      },
      BASE_URL: 'https://zhiyedashi.com/info',
      BASE_URL1: 'https://zhiyedashi.com/career',
      BASE_URL2: 'https://zhiyedashi.com/school',
      BASE_URL3: 'https://zhiyedashi.com/job',
      // BASE_URL: 'http://192.168.2.8:8206',
      // BASE_URL1: 'http://192.168.2.8:8203',
      // BASE_URL2: 'http://192.168.2.8:8205',
      // BASE_URL3: 'http://192.168.2.8:8204',
      parsedScores: [],
      scaledScores: [],
      jieguo: '',
      learningBackground: 0,
      learningAbility: 0,
      matchingResults: localStorage.getItem("matchingResults"),
      jobsfazhan: [],
      academicId: localStorage.getItem("academicId"),
      academic: {
        feature: [],
        improvement: [],
        suggestion: []
      },
      isMobile: false
    }
  },
  created() {
    // 1. 判断关键数据是否存在
    if (!this.userId) {
      // 2. 提前返回，跳过后续所有代码
      console.warn('关键数据未获取到，停止执行后续逻辑');
      this.$router.push('/')
    }
  },
  computed: {
    // 计算是否需要显示查看更多按钮
    showMoreButton() {
      return JSON.parse(this.matchingResults).length > 4
    },
    // 截取前4个岗位
    // displayedJobs() {
    //   return this.jobsfazhan.slice(0, 4)
    // }
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
    this.selectUserInfo()
    this.selectResumes()
    this.careerresult()
    this.fazhan()
    this.selectMore()
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    handleViewMore() {
      this.$router.push('/zhiyefangxiang');
    },
    fazhan() {
      fetch(`${this.BASE_URL3}/admin/jobliebiao/getFazhan`, {
        method: 'post',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `jobs=${this.matchingResults}`
      })
        .then(res => res.json())
        .then(data => {
          // console.log("123", data.data);
          this.jobsfazhan = data.data.slice(0, 4).map(item => ({
            jobName: item.jobName,
            majorSkills: item.majorSkills ? JSON.parse(item.majorSkills) : [], // 处理空值
            careerPath: item.careerPath || '暂无明确发展路径信息' // 处理空值
          }));
        })
        .catch(error => {
          console.error("查询失败，原因是", error);
        })
    },

    selectMore() {
      fetch(`${this.BASE_URL2}/admin/Academic/selectMore`, {
        method: 'post',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `academicId=${this.academicId}`
      })
        .then(res => res.json())
        .then(data => {
          this.academic.feature = JSON.parse(data.data.feature)
          this.academic.improvement = JSON.parse(data.data.improvement)
          this.academic.suggestion = JSON.parse(data.data.suggestion)
        })
        .catch(error => {
          console.error("查询失败，原因是", error);
        })
    },
    // 不同类型用不同颜色（可选）
    getColor(type) {
      const colors = {
        A: '#FF6B6B', // 红色 - 实用型
        C: '#4ECDC4', // 青色 - 常规型
        E: '#FFD166', // 黄色 - 企业型
        I: '#6A0572', // 紫色 - 调研型
        R: '#06D6A0', // 绿色 - 艺术型
        S: '#118AB2', // 蓝色 - 社会型
      };
      return colors[type] || '#999';
    },
    careerresult() {
      fetch(`${this.BASE_URL1}/admin/career/result/selectUserId`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `userId=${this.userId}`
      })
        .then(res => res.json())
        .then(data => {
          this.jieguo = data.data[0].result
          this.workExperience.typeScore = data.data[0].typeScore
          // console.log(this.jieguo);
          this.parseScores();
        })
        .catch(error => {
          console.error("查询失败，原因是", error);
        });
    },
    parseScores() {
      if (!this.workExperience.typeScore) {
        this.parsedScores = [];
        return;
      }
      this.parsedScores = this.workExperience.typeScore.split(';').map(item => {
        const [type, score] = item.split(':');
        return { type, originalScore: parseInt(score) };
      });
      // 3. 数据解析完成后，调用计算方法
      this.calculateScaledScores();
    },
    // 3. 计算缩放后的分数（遇5进1）
    calculateScaledScores() {
      this.scaledScores = this.parsedScores.map(item => {
        const scaled = Math.round((item.originalScore / 7) * 10); // 遇5进1
        return {
          ...item,
          scaledScore: scaled,
        };
      });
    },
    formatDate(dateString) {
      return dateString.split('T')[0];
    },
    selectUserInfo() {
      // 根据userId 去查询所有信息
      fetch(`${this.BASE_URL}/admin/user/info/selectUserInfo`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `userId=${this.userId}`
      })
        .then(res => res.json())
        .then(data => {
          this.basicInfo = data.data
        })
        .catch(error => {
          console.error("查询失败，原因是", error);
        });
    },
    selectResumes() {
      // 根据userId 去查询所有信息
      fetch(`${this.BASE_URL}/admin/resumes/selectResumes`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `userId=${this.userId}`
      })
        .then(res => res.json())
        .then(data => {
          this.collegeReport = data.data
          this.workExperience = data.data
          this.collegeReport.certificate = JSON.parse(data.data.certificate).join("，");
          this.workExperience.internship = JSON.parse(data.data.internship).join("，");
          const dataArray = JSON.parse(data.data.academic);

          // 2. 转换为 "科目：分数，科目：分数" 格式
          this.collegeReport.academic = dataArray.map(item => `${item.subject}：${item.score}`).join("，");
          let scores = dataArray.map(item => parseFloat(item.score));

          // 2. 计算平均分
          this.learningAbility = parseFloat((scores.reduce((sum, score) => sum + score, 0) / scores.length).toFixed(0));
          this.selectRanking()
        })
        .catch(error => {
          console.error("查询失败2，原因是", error);
        });
    },
    selectRanking() {
      fetch(`${this.BASE_URL2}/admin/school/selectBaifenbi`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `schoolName=${this.collegeReport.almaMater}`
      })
        .then(res => res.json())
        .then(data => {
          this.learningBackground = (data * 100).toFixed(0)
        })
        .catch(error => {
          console.error("查询百分比失败，原因是", error);
        });
    },
  }
}
</script>
<style scoped>
.hengtiao1 {
  position: fixed;
  height: 8px;
  width: 100%;
  background-color: white;
  display: flex;
  align-items: center;
  z-index: 99;
}

.hengtiao {
  position: fixed;
  height: 50px;
  width: 100%;
  background-color: #3572e5;
  color: white;
  display: flex;
  align-items: center;
  z-index: 99;
  margin-top: 8px;
}

.xiangji {
  margin-left: 20px;
  font-weight: 800;
  font-size: 28px;
}

.xiangji2 {
  font-weight: 900;
  font-size: 155px;
  border: 1px soild #DCDFE6;
}

.gerenxinxi {
  margin-left: 20px;
  font-weight: 700;
}

.holland-chart-container {
  font-family: Arial, sans-serif;
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
}

h2 {
  text-align: center;
  margin-bottom: 30px;
  color: #333;
}

.single-chart {
  margin-bottom: 25px;
}

.chart-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.type-label {
  font-size: 18px;
  font-weight: bold;
}

.score-label {
  font-size: 14px;
  color: #666;
}

.chart-bar-container {
  position: relative;
  height: 30px;
  background-color: #f0f0f0;
  border-radius: 15px;
  overflow: hidden;
}

.chart-bar-bg {
  position: absolute;
  width: 100%;
  height: 100%;
}

.chart-bar-progress {
  position: absolute;
  height: 100%;
  transition: width 0.3s ease;
}

.chart-ticks {
  position: absolute;
  top: 35px;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.tick {
  position: absolute;
  transform: translateX(-50%);
  font-size: 12px;
  color: #999;
}

.personal-info-page {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
  margin-top: 50px;
}

h1 {
  text-align: center;
  color: #333;
}

.section {
  margin-bottom: 30px;
  padding: 15px;
  border: 1px solid #eee;
  border-radius: 5px;
}

h2 {
  color: #444;
  border-bottom: 1px solid #eee;
  padding-bottom: 8px;
}

.info-row {
  display: flex;
  margin: 10px 0;
}

label {
  width: 150px;
  font-weight: bold;
  color: #555;
  flex-shrink: 0;
  text-align: left;
}

span {
  flex: 1;
  color: #333;
  line-height: 25px;
}

.chart-container {
  margin-top: 30px;
}

.bar-container {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.bar-label {
  width: 100px;
  text-align: right;
  margin-right: 15px;
  font-weight: bold;
}

.bar-background {
  flex-grow: 1;
  height: 20px;
  background-color: #f0f0f0;
  border-radius: 4px;
  overflow: hidden;
}

.bar-fill {
  height: 100%;
  transition: width 0.5s ease;
}

/* 学习背景条颜色（绿色） */
.background-bar {
  background-color: #4CAF50;
}

/* 学习能力条颜色（蓝色） */
.ability-bar {
  background-color: #2196F3;
}

.bar-value {
  width: 50px;
  text-align: right;
  margin-left: 10px;
  font-weight: bold;
}

.view-more-btn {
  padding: 8px 16px;
  background-color: #409eff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

@media (max-width: 768px) {
  .hengtiao {
    height: 50px;
    width: 100%;
    background-color: #3572e5;
    color: white;
    display: flex;
    align-items: center;
    position: static;
    margin-top: 0px;
  }

  .personal-info-page {
    max-width: 100%;
    margin: 0 auto;
    margin-top: 140px;
    padding: 10px 0px;
  }

  .logo {
    width: 50px;
  }

  .holland-chart-container {
    padding: 5px 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/usereport.vue